import { Link } from "react-router-dom";
import { Input } from "@/components/ui/input";

export const formatPhone = (v) => {
  const d = v.replace(/\D/g, "").replace(/^1/, "").slice(0, 10);
  if (d.length < 4) return d;
  if (d.length < 7) return `(${d.slice(0, 3)}) ${d.slice(3)}`;
  return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`;
};

export const contactErrors = (c) => ({
  name: c.name.trim() ? null : "Please enter your name",
  phone: c.phone.replace(/\D/g, "").length === 10 ? null : "Enter a 10-digit phone number",
  email: /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(c.email.trim()) ? null : "Enter a valid email",
  city: c.city.trim() ? null : "Please enter your city",
  zip: /^\d{5}$/.test(c.zip) ? null : "Enter a 5-digit ZIP",
});

const Field = ({ label, error, showError, ...props }) => (
  <label className="block">
    <span className="text-sm font-semibold text-slate-700">{label}</span>
    <Input {...props}
      className={`mt-1.5 h-14 rounded-xl border bg-white text-[17px] shadow-soft focus-visible:ring-0 focus-visible:border-[color:var(--brand)] ${
        showError && error ? "border-red-400" : "border-slate-200"
      }`} />
    {showError && error && <span className="mt-1 block text-sm text-red-600" data-testid={`${props["data-testid"]}-error`}>{error}</span>}
  </label>
);

export const ContactStep = ({ value, onChange, showErrors }) => {
  const errors = contactErrors(value);
  const set = (k) => (e) => onChange({ ...value, [k]: k === "phone" ? formatPhone(e.target.value) : k === "zip" ? e.target.value.replace(/\D/g, "").slice(0, 5) : e.target.value });
  return (
    <div className="space-y-4">
      <Field label="Full name" value={value.name} onChange={set("name")} autoComplete="name" placeholder="Jane Smith"
        error={errors.name} showError={showErrors} data-testid="contact-name-input" />
      <Field label="Phone" type="tel" inputMode="tel" value={value.phone} onChange={set("phone")} autoComplete="tel"
        placeholder="(856) 555-0123" error={errors.phone} showError={showErrors} data-testid="contact-phone-input" />
      <Field label="Email" type="email" inputMode="email" value={value.email} onChange={set("email")} autoComplete="email"
        placeholder="jane@email.com" error={errors.email} showError={showErrors} data-testid="contact-email-input" />
      <div className="grid grid-cols-[1fr_120px] gap-3">
        <Field label="City" value={value.city} onChange={set("city")} autoComplete="address-level2" placeholder="Cherry Hill"
          error={errors.city} showError={showErrors} data-testid="contact-city-input" />
        <Field label="ZIP" inputMode="numeric" value={value.zip} onChange={set("zip")} autoComplete="postal-code"
          placeholder="08002" error={errors.zip} showError={showErrors} data-testid="contact-zip-input" />
      </div>
      <p className="text-xs text-slate-500">Your info is only shared with this contractor. No spam, ever.</p>
      <p className="text-xs leading-relaxed text-slate-500" data-testid="contact-legal-notice">
        By sending, you agree to the <Link to="/terms" target="_blank" rel="noopener noreferrer" className="underline" data-testid="contact-terms-link">Terms of Service</Link> and{" "}
        <Link to="/privacy" target="_blank" rel="noopener noreferrer" className="underline" data-testid="contact-privacy-link">Privacy Policy</Link>, and to be contacted about your project.
        Any price estimate is preliminary and not a quote.
      </p>
    </div>
  );
};
